import styled from 'styled-components';
import { Colors } from '../../themes';

export const Text = styled.h1`
  font-size: 2rem;
  font-weight: 100;
  color: ${props => props.color || Colors.text.main};

  highlight {
    border-bottom: 2px solid #ee1f99;
  }

  @media (max-width: 1024px) {
    /* font-size: 9.1vw; */
    margin: 2% 15% 0 15%;
  }

  @media (max-width: 960px) {
    /* font-size: 9.1vw; */
  }
`;
